import { Theme } from "@mui/material";

import { lightOrDark } from "@app/embedded/theme/utils";

export const DROPDOWN_STYLES = {
  minHeight: "40px",
  ".MuiSelect-select": {
    color: (theme: Theme) =>
      lightOrDark("shades.neutral.600", "shades.neutral.50")(theme),
    fontSize: "0.875rem",
    fontFamily: (theme: Theme) => theme.typography.fontFamily,
  },
  "&.MuiList-root": {
    p: 1,
  },
  "&.Mui-disabled": {
    bgcolor: "shades.neutral.50",
  },
  "& .MuiSelect-icon": {
    p: 0.5,
    color: (theme: Theme) =>
      lightOrDark("shades.neutral.500", "shades.neutral.50")(theme),
  },
};

export const TEXT_VARIANT_STYLES = {
  ".MuiOutlinedInput-notchedOutline": {
    display: "none",
  },
  "&:hover:not(.Mui-focused):not(.Mui-disabled) > .MuiOutlinedInput-notchedOutline":
    {
      border: "none",
    },
};
